import React from "react"

const EtaDtXdHeader = (props) => {
    return (
        <React.Fragment>
            <span>XD ETA Date</span>
            <span
                style={{
                    fontSize: '9px',
                    marginLeft: '2px'
                }}
            >
                ( MM/DD/YYYY )
            </span>
        </React.Fragment>
    )
}

const EtaTmXdHeader = (props) => {
    return (
        <React.Fragment>
            <span>XD ETA Time</span>
            <span
                style={{
                    fontSize: '10px',
                    marginLeft: '2px'
                }}
            >
                ( HH:mm )
            </span>
        </React.Fragment>
    )
}

export {EtaDtXdHeader, EtaTmXdHeader}
